module.exports = __webpack_public_path__ + "static/media/iphone 12 pro max banner2.7ccfaa1a.jpg";